module.exports = __webpack_public_path__ + "static/phone-c6b09a567924c189ac0b865fa36a4585.png";